import React from 'react';
import { Button } from 'react-bootstrap';
import { Lightbulb, PlusCircle } from 'react-bootstrap-icons';
import { LiveSuggestion, SignalCategory } from '../../types/context.types';
import SemanticBreadcrumb from './SemanticBreadcrumb';
import './LiveSuggestions.css';

interface LiveSuggestionsProps {
  suggestions: LiveSuggestion[];
  readinessScore: number;
  onAddAsSignal?: (text: string, category: SignalCategory) => void;
  onSourceClick?: (sourceId: string) => void;
}

const PILLAR_LABELS: Record<string, string> = {
  data_sources: 'Data Sources',
  manual_tags: 'Manual Tags',
  interactions: 'Interactions',
};

const LiveSuggestions: React.FC<LiveSuggestionsProps> = ({
  suggestions,
  readinessScore,
  onAddAsSignal,
  onSourceClick,
}) => {
  if (suggestions.length === 0) {
    if (readinessScore >= 80) {
      return (
        <div className="live-suggestions empty">
          <p className="empty-message">Your context is looking great!</p>
        </div>
      );
    }
    return (
      <div className="live-suggestions empty">
        <p className="empty-message">Start by uploading a document or adding tags</p>
      </div>
    );
  }

  return (
    <div className="live-suggestions">
      {suggestions.slice(0, 5).map((suggestion) => (
        <div key={suggestion.id} className="suggestion-item">
          <div className="suggestion-header">
            <Lightbulb size={14} className="suggestion-icon" />
            <span className="suggestion-pillar">{PILLAR_LABELS[suggestion.pillar] || suggestion.pillar}</span>
            <span className="suggestion-impact">+{suggestion.pillarImpact}</span>
          </div>
          <p className="suggestion-text">{suggestion.text}</p>
          {suggestion.breadcrumbs && suggestion.breadcrumbs.length > 0 && (
            <div className="suggestion-breadcrumbs">
              {suggestion.breadcrumbs.map((bc, i) => (
                <SemanticBreadcrumb
                  key={i}
                  sourceId={bc.sourceId}
                  fileName={bc.fileName}
                  excerpt={bc.excerpt}
                  onClick={onSourceClick}
                />
              ))}
            </div>
          )}
          {suggestion.type === 'insight' && onAddAsSignal && (
            <Button
              variant="link"
              size="sm"
              className="add-as-signal-btn p-0"
              onClick={() => onAddAsSignal(suggestion.text, 'insight')}
            >
              <PlusCircle size={12} className="me-1" />
              Add as signal
            </Button>
          )}
        </div>
      ))}
    </div>
  );
};

export default LiveSuggestions;
